import axios from "axios";

const envUrl = process.env.REACT_APP_BACKEND_URL || "";
const isBrowser = typeof window !== "undefined";
const isLocalhost = isBrowser && /^https?:\/\/(localhost|127\.0\.0\.1)/.test(window.location.origin);
// Prefer same-origin in the browser (deployed). Fall back to env var for localhost dev.
const BACKEND_URL = isBrowser && !isLocalhost ? window.location.origin : envUrl;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });
